import React from 'react';
import { Trash2 } from 'lucide-react';

import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { ToolBtn } from '../../shared/ui/tool-btn';
import { AttachToRow, AttachToConfig } from '../../layout';
import { usePieceDispatch } from '../../model/piece-context';
import { LayerId } from '../../model/types';
import { PillTextbox, isPillTextbox } from '../types';
import { swapPillSidePaddings } from '../utils/pill-accessors';
import { PillColorRow } from './pill-color-row';
import { PillStrokeRow } from './pill-stroke-row';
import { PillTypographyRow } from './pill-typography-row';
import { PillShapeRow } from './pill-shape-row';
import { PillSizeRow } from './pill-size-row';
import { PillChainPaddingRow } from './pill-chain-padding-row';
import { rowStyle } from './pill-styles';

export const PillSettings: React.FC = () => {
  const { canvas, selectedObject, deleteSelected } = useEditorCanvas();
  const dispatch = usePieceDispatch();
  if (!canvas || !isPillTextbox(selectedObject)) return null;

  const pill: PillTextbox = selectedObject;
  const id = pill.layerId as LayerId | undefined;

  const commitAttach = (attachTo?: AttachToConfig) => {
    if (id) dispatch({ type: 'setLayerAttach', id, attachTo });
  };

  const onSideChange = () => {
    swapPillSidePaddings(pill); // preview
    if (id)
      dispatch({
        type: 'patchLayerContent',
        id,
        patch: { paddingLeft: pill.pill.paddingLeft, paddingRight: pill.pill.paddingRight }
      });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={rowStyle}>
        <PillColorRow pill={pill} />
        <PillStrokeRow pill={pill} />
      </div>
      <PillTypographyRow pill={pill} />
      <PillShapeRow pill={pill} />
      <PillSizeRow pill={pill} />
      <AttachToRow obj={pill} canvas={canvas} onCommit={commitAttach} onSideChange={onSideChange} />
      <PillChainPaddingRow pill={pill} />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ToolBtn onClick={deleteSelected} variant='danger' title='Eliminar'>
          <Trash2 size={15} />
        </ToolBtn>
      </div>
    </div>
  );
};
